import { EditFlightResponseMapped } from '@shared/services/flight/_interfaces_/booked-flight.mapped.interface';

export class SearchDataModel {
  data: EditFlightResponseMapped = {} as EditFlightResponseMapped;
}
